function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.973 117.115L42.0287 126.822V167.505H42.1844L59.2138 184L76.2432 167.505L66.091 157.704V117.115L49.0335 100.587L31.973 117.115Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.973 80.96L49.1892 63.7867L66.4054 80.96L49.1892 98.1334L31.973 80.96Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.295 0L0 19.2704V166.827L22.8466 143.182L23.1126 109.814L12.5907 98.9214L22.8761 88.2768L22.8466 28.7251L34.4324 16.7316L18.295 0Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.431 172.07C89.2466 172.56 88.9699 172.99 88.6317 173.327C88.2935 173.695 87.8939 173.971 87.402 174.186C86.9408 174.4 86.4213 174.492 85.8648 174.492C85.3114 174.492 84.7888 174.4 84.2969 174.186C83.805 173.971 83.4054 173.695 83.0672 173.327C82.729 172.959 82.4523 172.53 82.2679 172.07C82.0834 171.579 81.9604 171.058 81.9604 170.506C81.9604 169.957 82.0527 169.435 82.2679 168.942C82.4523 168.451 82.729 168.025 83.0672 167.684C83.4054 167.316 83.8358 167.04 84.2969 166.826C84.7888 166.614 85.2807 166.519 85.8648 166.519C86.4213 166.519 86.9408 166.614 87.402 166.826C87.8631 167.04 88.2935 167.316 88.6317 167.684C88.9699 168.052 89.2466 168.451 89.431 168.942C89.6186 169.435 89.7385 169.957 89.7385 170.506C89.7077 171.058 89.6186 171.579 89.431 172.07ZM90.0767 168.696C89.8307 168.147 89.5233 167.657 89.0929 167.258C88.6625 166.856 88.1706 166.519 87.6172 166.274C87.0638 166.028 86.4797 165.906 85.8341 165.906C85.1885 165.906 84.6044 166.028 84.0202 166.274C83.4699 166.519 82.975 166.856 82.5446 167.258C82.1141 167.657 81.8098 168.147 81.5608 168.696C81.3456 169.279 81.2226 169.862 81.2226 170.506C81.2226 171.15 81.3456 171.735 81.5915 172.315C81.8375 172.867 82.1756 173.358 82.5784 173.79C82.975 174.216 83.4976 174.523 84.051 174.768C84.6044 174.983 85.2192 175.106 85.8341 175.106C86.4797 175.106 87.0638 174.983 87.6172 174.738C88.1706 174.492 88.6625 174.158 89.0929 173.756C89.5233 173.327 89.8307 172.867 90.0767 172.284C90.3226 171.735 90.4456 171.119 90.4456 170.506C90.4456 169.862 90.3226 169.279 90.0767 168.696Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.2973 170.201H85.7132H84.7601V168.388H86.2327C86.3864 168.388 86.5432 168.388 86.697 168.422C86.8507 168.453 87.0013 168.48 87.0966 168.545C87.2196 168.603 87.3118 168.698 87.401 168.821C87.4963 168.943 87.524 169.097 87.524 169.311C87.524 169.557 87.4655 169.768 87.3426 169.891C87.2196 170.014 87.0659 170.109 86.8783 170.167C86.7277 170.167 86.5094 170.201 86.2973 170.201ZM87.7422 170.354C87.8959 170.231 87.9882 170.109 88.0804 169.922C88.1696 169.741 88.2003 169.523 88.2003 169.278C88.2003 168.851 88.0804 168.511 87.8006 168.299C87.524 168.054 87.0659 167.931 86.3864 167.931H84.1453V173.053H84.7909V170.688H85.9591L87.4317 173.053H88.2003L86.6324 170.688C86.8507 170.688 87.0659 170.658 87.278 170.599C87.4317 170.566 87.5885 170.477 87.7422 170.354Z",
  fill: "white"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 184,
    viewBox: "0 0 91 184",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.dc6b2ede.svg";
export { ForwardRef as ReactComponent };